import { Badge, message, Popover } from 'antd'
import { FunctionComponent, lazy } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Link, useLocation } from 'react-router-dom'

import commonFallback from '@/home/src/assets/imgs/commonFallback.png'
import { CartDrawer } from '@api/home/detail/addCart/useAddCart'
import { useCartListDrawer } from '@api/home/detail/addCart/useCartListDrawer'
import { Image } from '@ui-pc'
import { loTrack } from '@utils'
import { Type } from '@utils/tool'

import { updateUserInfo } from '../../../../../ind/api/home/store/slice/appSlice'
import { userLogout } from '@api/home/store/slice/loginSlice'
import { routesPath } from '../../../../../ind/api/home/utils'
import logoImg from '../../assets/imgs/logo.png'
import NavigationMenu from '../NavigationMenu'
import SearchInput from '../SearchInput'
import styles from './index.module.scss'

import type { RootState } from '@api/home/store'

interface ICommonHeaderProps {}

export const Logo = (props: {
  className?: string
  style?: React.CSSProperties
  to?: string
  disabledNavigate?
}) => {
  const {
    className = styles['site-logo'],
    to = '/',
    disabledNavigate,
    style = {}
  } = props
  const logoPath = useSelector((state: RootState) => state.app.logoPath)
  return (
    <div
      onClick={() => {
        if (disabledNavigate) {
          return
        }
        window.location.href = to
      }}
      className={className}
    >
      <Image
        preview={false}
        fallback={commonFallback}
        style={style}
        src={logoPath}
        alt='yitahome'
      />
    </div>
  )
}

const ShopCartIcon = () => {
  const handler = useCartListDrawer({
    title: 'Your Cart',
    isRefetch: true
  })

  return (
    <Badge count={Type.number(handler.totalNum)}>
      <i
        onClick={() => {
          handler.setOpen(true)
        }}
        className={`iconfont icon-cart ${styles['header-icon']}`}
      ></i>
      <CartDrawer {...handler} />
    </Badge>
  )
}

const CommonHeader: FunctionComponent<ICommonHeaderProps> = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  // store数据
  const isLogin = useSelector((state: any) => state.app.isLogin, shallowEqual)

  const showLoginModal = () => {
    dispatch({
      type: 'login/triggleLogin',
      payload: true
    })

    loTrack('Heaher_Sign in')
  }

  const handleLogout = () => {
    userLogout().then((res) => {
      if (res.code === 200) {
        messageApi.open({
          type: 'success',
          content: res.message
        })
        dispatch(updateUserInfo({}))
        if (location.pathname !== '/') {
          navigate('/')
        }
      } else {
        messageApi.error(res.message)
      }
    })
  }

  const userMenuContent = (
    <div className={styles['header-user']}>
      <ul className={styles['user-menu']}>
        {/* <li>
          <Link to="/">My Account</Link>
        </li> */}
        <li>
          <Link to={`${routesPath.user}${routesPath.order}`.substring(1)}>
            All Orders
          </Link>
        </li>
      </ul>
      <p className={styles['logout']} onClick={handleLogout}>
        Sign Out
      </p>
    </div>
  )

  return (
    <header className={`${styles['header']}`}>
      <div className={`global-section-inner`}>
        <div className={styles['main']}>
          <div className={styles['left']}>
            <Logo />
            {/* <dl className={styles['free-shipping']}>
            <dt>
              <i className="icon-ic_cart2 iconfont"></i>
            </dt>
            <dd>
              <b>Free Shipping</b>
              <br></br>
              <span>On All Orders</span>
            </dd>
          </dl> */}
          </div>

          <div className='search-modal-content'>
            <SearchInput isFixed={true} />
          </div>

          <div className={styles['right']}>
            {isLogin ? (
              <Popover
                placement='bottom'
                content={userMenuContent}
                trigger='hover'
                className={styles['user-popover']}
              >
                <i
                  className={`iconfont icon-Account ${styles['header-icon']}`}
                ></i>
              </Popover>
            ) : (
              <div onClick={showLoginModal}>
                <i
                  className={`iconfont icon-Account ${styles['header-icon']}`}
                ></i>
              </div>
            )}
            <ShopCartIcon />
          </div>
        </div>
      </div>
      <NavigationMenu />
    </header>
  )
}

export default CommonHeader
